/* download.css — Download status page (vertical-centered layout + progress bar) */

@import url('download-base.css');

body {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    padding: 0;
}

.container {
    text-align: center;
    max-width: 500px;
}

/* Progress bar */
.progress-container {
    width: 100%;
    height: 8px;
    background-color: #e0e0e0;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 10px;
}

.progress-bar {
    width: 0;
    height: 100%;
    background-color: #1976d2;
    transition: width 0.3s ease;
}

